import { render, staticRenderFns } from "./IpoInvestmentManagement.vue?vue&type=template&id=8b4bd9b0"
import script from "./IpoInvestmentManagement.vue?vue&type=script&lang=js"
export * from "./IpoInvestmentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports